import React, { Component } from 'react';

import ErrorMessageRefresh from './ErrorMessageRefresh';
import ErrorMessageRetry from './ErrorMessageRetry';
import cn from 'utils/cn';

class ErrorBoundary extends Component {
  state = {
    error: false,
    info: '',
  };

  componentDidCatch(error, info) {
    this.setState({ error, info });
  }

  render() {
    const {
      callback,
      children,
      hasError,
      containerClass,
      errorMessageWidth = 492,
      accessDeniedWidth,
      testId,
    } = this.props;
    const { error } = this.state;

    const accessDenied = (
      <div
        data-testid={testId || 'access-denied-error-boundry'}
        className={cn(
          'tw:flex-col tw:flex tw:items-center',
          containerClass ? containerClass : 'tw:my-8'
        )}
      >
        <div
          className={cn(
            'tw:rounded-lg tw:p-8 tw:bg-primary-100',
            accessDeniedWidth ? accessDeniedWidth : 'tw:w-30'
          )}
          style={{ boxShadow: '0 0 20px 0 rgba(0,0,0,0.2)' }}
        >
          <p className="tw:text-brand-300 tw:text-4xl tw:my-2 tw:text-center">Access Denied</p>
          <p className="tw:text-center tw:font-light">
            Sorry, you don't have permission to access this page
          </p>
        </div>
      </div>
    );

    if (error || hasError) {
      if (error.message == 401) {
        return accessDenied;
      } else {
        return callback ? (
          <ErrorMessageRetry
            containerProps={{ className: containerClass }}
            errorMessageProps={{
              style: {
                width: errorMessageWidth,
              },
            }}
            callback={callback}
            resetState={() => this.setState({ error: false, info: '' })}
          />
        ) : (
          <ErrorMessageRefresh
            containerProps={{ className: containerClass }}
            errorMessageProps={{
              style: {
                width: errorMessageWidth,
              },
            }}
          />
        );
      }
    } else {
      return children;
    }
  }
}

export default ErrorBoundary;
